define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ManagerDeleteModel = /** @class */ (function () {
        function ManagerDeleteModel(data) {
            this.Id = ko.observable(0);
            this.NewId = ko.observable(0);
            this.Name = ko.observable();
            this.NewCustomerLabel = ko.observable();
            this.DeleteLabel = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ManagerDeleteModel.Mapping, self);
            }
        }
        ManagerDeleteModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ManagerDeleteModel(options.data);
            }
        };
        return ManagerDeleteModel;
    }());
    return ManagerDeleteModel;
});
//# sourceMappingURL=ManagerDeleteModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ManagerDeleteModel.js
// module id = 33
// module chunks = 2